import { ProductCard } from '../molecules/ProductCard';
import type { VendorProduct } from '../../types';
import type { ProductActionType } from '../../types/product-actions.types';

interface ProductsSectionProps {
  products: VendorProduct[];
  memberIdNameMapping: Record<string, string>;
  onViewAssessment?: (productId: string) => void;
  onProductAction?: (action: ProductActionType, product: VendorProduct) => void;
  onNewAssessment?: () => void;
  className?: string;
}

export const ProductsSection = ({
  products,
  memberIdNameMapping,
  onViewAssessment,
  onProductAction,
  onNewAssessment,
  className = '',
}: ProductsSectionProps) => {
  const hasProducts = products.length > 0;

  return (
    <section className={`flex flex-col items-flex-start p-4 gap-4 bg-white shadow-[0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_rgba(0,0,0,0.06)] rounded-lg ${className}`}>
      {/* Section Header */}
      <h2 className="w-full font-['Inter'] font-medium text-sm leading-5 text-[#0F172B]">
        Products
      </h2>

      {/* Products List or Empty State */}
      {hasProducts ? (
        <div className="flex flex-col gap-2 w-full">
          {products.map((product) => {
            // Get user name from memberIdNameMapping, matching VersionCard pattern
            const userId = product.created_by;
            let assigneeName = 'Unknown';

            if (userId) {
              if (memberIdNameMapping && memberIdNameMapping[userId]) {
                assigneeName = memberIdNameMapping[userId];
              }
            }

            return (
              <ProductCard
                key={product.id}
                product={product}
                assigneeName={assigneeName}
                onViewAssessment={onViewAssessment}
                onAction={onProductAction}
              />
            );
          })}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <p className="font-['Inter'] font-normal text-sm text-[#62748E]">
            No products available
          </p>
        </div>
      )}
    </section>
  );
};
